export const MENU_NAV_ITEMS = [
  { label: 'Planificador', value: 'planner', iconName: 'planner' },
  { label: 'Mapa', value: 'map', iconName: 'map' },
  { label: 'Chatbot', value: 'chatbot', iconName: 'chatbot' },
  { label: 'Enviar', value: 'more', iconName: 'email' },
]